import { render, staticRenderFns } from "./courseTabs.vue?vue&type=template&id=e18b41b0&scoped=true&"
import script from "./courseTabs.vue?vue&type=script&lang=js&"
export * from "./courseTabs.vue?vue&type=script&lang=js&"
import style0 from "./courseTabs.vue?vue&type=style&index=0&id=e18b41b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18b41b0",
  null
  
)

export default component.exports